// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import SearchResult from './SearchResult'

class SearchResultsOther extends React.Component {
	render() {
		const { searchResults } = this.props
		let newsMarkup = false

		if ( searchResults && Object.keys( searchResults.news ).length ) {
			newsMarkup = Object.keys( searchResults.news ).map( ( key ) => {
				let item = searchResults.news[ key ]

				return (
					<SearchResult key={ item.id } searchResult={ item } />
				);
			});
		}

		return (
			<div className="-other-results-wrap">
				<div className="-other-results">
					{ newsMarkup }
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		searchResults: state.search.searchResults
	}
}

export default connect( mapStateToProps )( SearchResultsOther )
